module.exports = __webpack_public_path__ + "img/img_title_advantage_06.bdf1da2f.png";